
import { loadSectionTranslations } from '../../../i18n-setup'

export default {
  name: 'RtrBannerInfo',
  props: {
    productsInfo: {
      default: () => [],
      type: Array,
    },
    textColorClass: {
      type: String,
      default: '',
    },
    isWhiteColor: {
      type: Boolean,
      default: false,
    },
    bannerTitle: {
      type: String,
      default: '',
    },
    buttonCategory: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      selectedIndex: 0,
    }
  },
  computed: {
    isMobile() {
      return this.$mq === 'tablet' || this.$mq === 'tabletLandscape'
    },
    selectedProduct() {
      return this.productsInfo[this.selectedIndex]
    },
    isDark() {
      return this.textColorClass.includes('text-white')
    },
  },
  mounted() {
    loadSectionTranslations('cms')
  },
  methods: {
    selectProduct(index) {
      this.$emit('change-index', index)
      this.selectedIndex = index
    },
    onmouseenter(index) {
      this.$emit('rtr-preload-index', index)
    },
    imgSrc(upc) {
      return `https://assets.sunglasshut.com/is/image/LuxotticaRetail/${upc}__STD__shad__cfr.png?impolicy=SGH_bgtransparent&width=320`
    },
  },
}
